import { HttpClient } from '@angular/common/http';
import { APIBaseManager } from '../../api.base';

export interface IPauseVirtualDeviceShadowPathParameter {
    virtualDeviceID: string;
}

export interface IPauseVirtualDeviceShadowTxData {
    pauseDurationInSeconds: number;
}

export class APIPauseVirtualDeviceShadowManager extends APIBaseManager<IPauseVirtualDeviceShadowPathParameter, void, IPauseVirtualDeviceShadowTxData, any> {
    constructor(protected http: HttpClient) {
        super(http);
        this._apiName = 'API_PauseVirtualDeviceShadow';
        this._apiMethod = 'POST';
    }

    protected getRequestURL(pathParameters: IPauseVirtualDeviceShadowPathParameter, queryParameters: void): string {
        return super.getRequestURL() + 'virtualDevices/' + pathParameters.virtualDeviceID + '/shadow/pause';
    }
}